import { render, staticRenderFns } from "./SettingDrawer.vue?vue&type=template&id=37faf8e2&scoped=true"
import script from "./SettingDrawer.vue?vue&type=script&lang=js"
export * from "./SettingDrawer.vue?vue&type=script&lang=js"
import style0 from "./SettingDrawer.vue?vue&type=style&index=0&id=37faf8e2&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37faf8e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37faf8e2')) {
      api.createRecord('37faf8e2', component.options)
    } else {
      api.reload('37faf8e2', component.options)
    }
    module.hot.accept("./SettingDrawer.vue?vue&type=template&id=37faf8e2&scoped=true", function () {
      api.rerender('37faf8e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/setting/SettingDrawer.vue"
export default component.exports